import React, { useState, useEffect } from 'react';
import NavigationHeader from '../../components/ui/NavigationHeader';
import RevenueExpenseChart from './components/RevenueExpenseChart';
import DREComparisonTable from './components/DREComparisonTable';
import Button from '../../components/ui/Button';

const FinancialOverviewDashboard = () => {
  const [dateRange, setDateRange] = useState({
    start: new Date(2025, 7, 1),
    end: new Date(2025, 7, 29),
    preset: 'month'
  });
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  // Revenue vs Expense (mock, mantido)
  const revenueExpenseData = [
    { date: '2025-06-01', receitas: 42000, despesas: 28000 },
    { date: '2025-06-05', receitas: 38000, despesas: 26500 },
    { date: '2025-06-10', receitas: 45000, despesas: 29000 },
    { date: '2025-06-15', receitas: 41000, despesas: 27500 },
    { date: '2025-06-20', receitas: 47000, despesas: 30000 },
    { date: '2025-06-25', receitas: 43000, despesas: 28500 },
    { date: '2025-06-30', receitas: 49000, despesas: 31000 },
    { date: '2025-07-05', receitas: 44000, despesas: 29500 },
    { date: '2025-07-10', receitas: 46000, despesas: 30500 },
    { date: '2025-07-15', receitas: 42000, despesas: 28000 },
    { date: '2025-07-20', receitas: 48000, despesas: 31500 },
    { date: '2025-07-25', receitas: 45000, despesas: 29000 },
    { date: '2025-07-30', receitas: 50000, despesas: 32000 },
    { date: '2025-08-05', receitas: 47000, despesas: 30000 },
    { date: '2025-08-10', receitas: 49000, despesas: 31000 },
    { date: '2025-08-15', receitas: 46000, despesas: 29500 },
    { date: '2025-08-20', receitas: 51000, despesas: 32500 },
    { date: '2025-08-25', receitas: 48000, despesas: 30500 },
    { date: '2025-08-29', receitas: 52000, despesas: 33000 }
  ];

  const handleDateChange = (newRange) => setDateRange(newRange);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      setLastUpdated(new Date());
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => setLastUpdated(new Date()), 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader
        notificationCount={3}
        onDateChange={handleDateChange}
        currentDateRange={dateRange}
        onToggleSidebar={() => {}}
      />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-heading-bold text-foreground mb-2">Financeiro</h1>
              <p className="text-muted-foreground">
                Centralize DRE, contas a pagar, contas a receber e cobranças automáticas.
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-sm text-muted-foreground">
                Última atualização: {lastUpdated?.toLocaleTimeString('pt-BR')}
              </div>
              <Button variant="outline" size="sm" iconName="RefreshCw" iconPosition="left"
                onClick={handleRefresh} loading={isRefreshing}>Atualizar</Button>
              <Button variant="default" size="sm" iconName="Download" iconPosition="left"
                onClick={() => console.log('Exportando dashboard completo...')}>Exportar</Button>
            </div>
          </div>

          {/* DRE (filtros internos) */}
          <div className="mb-8">
            <DREComparisonTable />
          </div>

          {/* Quick Actions */}
          <div className="bg-card rounded-lg border border-border p-6 card-shadow">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-heading-semibold text-lg text-card-foreground mb-2">Abas do Financeiro</h3>
                <p className="text-sm text-muted-foreground">Acesse rapidamente as rotinas financeiras pedidas pelo cliente</p>
              </div>
              <div className="flex items-center space-x-3">
                <Button variant="outline" size="sm" iconName="BarChart3" iconPosition="left"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  DRE
                </Button>
                <Button variant="outline" size="sm" iconName="Receipt" iconPosition="left"
                  onClick={() => (window.location.href = '/accounts-receivable-management-dashboard')}>
                  Contas a Receber
                </Button>
                <Button variant="outline" size="sm" iconName="CreditCard" iconPosition="left"
                  onClick={() => (window.location.href = '/accounts-payable-management-dashboard')}>
                  Contas a Pagar
                </Button>
                <Button variant="outline" size="sm" iconName="Send" iconPosition="left"
                  onClick={() => (window.location.href = '/billing-automation-dashboard')}>
                  Cobranças Automáticas
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FinancialOverviewDashboard;
